export default "__VITE_ASSET__4b1bbad8__"